export const REPLIES_LIMIT_ERROR_CODE = 'replies_limit';

export class RepliesLimitError extends Error {
    constructor(description, response) {
        super(description);
        this.name = 'RepliesLimitError';
        this.isRepliesLimit = true;
        this.response = response;
    }
}

export const isRepliesLimitResponse = data =>
    data?.success === false && (data.errorCode ?? data.error_code) === REPLIES_LIMIT_ERROR_CODE;

// Moves on when the dashboard's range or search changes, so a late answer to an earlier request is not toasted.
let repliesLimitScope = 0;
let dismissedRepliesLimitScope;

export const nextRepliesLimitScope = () => {
    repliesLimitScope += 1;
};

// A 401 retry re-sends the same config; it still belongs to the scope it was first sent in.
export const stampRepliesLimitScope = config => {
    if (config.repliesLimitScope === undefined) {
        config.repliesLimitScope = repliesLimitScope;
    }
};

export const isStaleRepliesLimitError = error => {
    const sentInScope = error?.response?.config?.repliesLimitScope;

    return sentInScope !== undefined && sentInScope < repliesLimitScope;
};

// For requests that aren't the displayed search (selector counts, previous period): the caller's own message replaces
// the persistent toast. A stale error passes through untouched so $toasterError still drops it silently.
export const exceptRepliesLimit = error => (error?.isRepliesLimit && !isStaleRepliesLimitError(error) ? null : error);

export const dismissRepliesLimitToast = () => {
    dismissedRepliesLimitScope = repliesLimitScope;
};

export const isRepliesLimitToastDismissed = () => dismissedRepliesLimitScope === repliesLimitScope;
